import { Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import { pisMask } from 'utils/masks'

export default function CustomFormPISAnswer() {
  const { answer } = useCustomFormAnswer()

  if (!answer.answer) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Sem resposta
      </Text>
    )
  }

  const [pis] = answer.answer

  return <Text color="primary">{pisMask(pis)}</Text>
}
